import React from 'react';

/**
 * Card de indicador (KPI). Havia cinco implementações praticamente iguais
 * espalhadas em Resultado, Cargas, Home, PainelLavoura e MinhaAssinatura.
 *
 * A cor vem de `tom`, não de um hexadecimal: antes cada página escrevia o
 * próprio "#276749" e o verde de receita mudava de tela para tela.
 *
 * @param label     rótulo curto, exibido em maiúsculas
 * @param value     valor já formatado
 * @param detalhe   linha secundária opcional (ex.: equivalência em sacas)
 * @param tom       'receita' | 'custo' | 'positivo' | 'negativo' | undefined
 * @param destaque  adiciona barra colorida no topo
 * @param dica      texto de ajuda no title (aparece ao passar o mouse)
 */
export default function Metrica({ label, value, detalhe, tom, destaque, dica }) {
  const classes = [
    'metrica',
    destaque ? 'metrica--destaque' : '',
    tom ? `metrica--${tom}` : '',
  ].filter(Boolean).join(' ');

  return (
    <div className={classes} title={dica}>
      <div className="metrica-label">
        {label}
        {dica && <span className="metrica-dica" aria-hidden="true">?</span>}
      </div>
      <div className="metrica-valor">{value}</div>
      {detalhe && <div className="metrica-detalhe">{detalhe}</div>}
    </div>
  );
}

/** Grade responsiva para agrupar métricas. */
export function MetricaGrid({ children, min = 150 }) {
  return (
    <div className="metrica-grid" style={{ '--metrica-min': `${min}px` }}>
      {children}
    </div>
  );
}
